export const ru = {
    'new-video': 'Новое видео'
};
